
/*
 * VNCmail : A whole new experience in enterprise email communication.
 * Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, version 3 of the License.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. Look for COPYING file in the top folder.
 * If not, see http://www.gnu.org/licenses/.
 */

import { Component, OnInit, NgZone, OnDestroy } from "@angular/core";
import { MatDialogRef, MatDialog } from "@angular/material/dialog";
import { AboutDialogComponent } from "../about-dialog/about-dialog.component";
import { ServicedeskDialogComponent } from "../servicedesk-dialog/servicedesk-dialog.component";
import { HelpFaqDialogComponent } from "../help-faq-dialog/help-faq-dialog.component";
import { MailBroadcaster } from "src/app/common/providers/mail-broadcaster.service";
import { BroadcastKeys } from "src/app/common/enums/broadcast.enum";
import { take, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { LegalNoticeDialogComponent } from "../legal-notice-dialog/legal-notice-dialog.component";
import { ConfigService } from "src/app/config.service";
import { CommonUtils } from "src/app/common/utils/common-util";

@Component({
  selector: "vp-mobile-about-dialog",
  templateUrl: "./mobile-about-dialog.component.html"
})
export class MobileAboutDialogComponent implements OnInit, OnDestroy {
  private isAlive$ = new Subject<boolean>();
  hideFAQMenu: boolean = false;
  hideServiceDeskMenu: boolean = false;
  hideLegalNoticeMenu: boolean = false;
  serviceDeskMenuItemName: string = "VNC Service Desk";
  constructor(
    public dialogRef: MatDialogRef<MobileAboutDialogComponent>,
    private matDialog: MatDialog,
    private mailBroadcaster: MailBroadcaster,
    private ngZone: NgZone,
    private configService: ConfigService
  ) {
    this.mailBroadcaster.on<any>(BroadcastKeys.HIDE_ABOUT_DIALOG).pipe(takeUntil(this.isAlive$)).subscribe(res => {
      this.ngZone.run(() => {
        this.close();
      });
    });

    if (this.configService.showHideSettingsMenu.hideServiceDeskMenu) {
      this.hideServiceDeskMenu = this.configService.showHideSettingsMenu.hideServiceDeskMenu;
    }
    if (this.configService.showHideSettingsMenu.hideManualFAQ) {
      this.hideFAQMenu = this.configService.showHideSettingsMenu.hideManualFAQ;
    }
    if (this.configService.showHideSettingsMenu.serviceDeskHeaderText) {
      this.serviceDeskMenuItemName = this.configService.showHideSettingsMenu.serviceDeskHeaderText;
    }
    if (this.configService.showHideSettingsMenu.hideLegalNoticeMenu) {
      this.hideLegalNoticeMenu = this.configService.showHideSettingsMenu.hideLegalNoticeMenu;
    }
  }

  ngOnInit() {
    if (CommonUtils.isOnIOS()) {
      setTimeout(() => {
        document.querySelector(".cdk-global-overlay-wrapper").removeAttribute("style");
      }, 50);
    }
  }

  ngOnDestroy() {
    this.isAlive$.next(false);
    this.isAlive$.unsubscribe();
  }

  close(): void {
    this.dialogRef.close();
  }

  aboutDialog(): void {
    this.matDialog.open(AboutDialogComponent, {
      maxWidth: "100%",
      autoFocus: false,
      panelClass: "mail__dialog"
    });
  }

  serviceDeskDialog(): void {
    this.matDialog.open(ServicedeskDialogComponent, {
      maxWidth: "100%",
      autoFocus: false,
      panelClass: "mail__dialog"
    });
  }

  helpFaqDialog(): void {
    this.matDialog.open(HelpFaqDialogComponent, {
      maxWidth: "100%",
      autoFocus: false,
      panelClass: "mail__dialog"
    });
  }

  openLegaldialog(): void {
    this.matDialog.open(LegalNoticeDialogComponent, {
      maxWidth: "100%",
      autoFocus: false,
      panelClass: "mail__dialog"
    });
  }
}
